import { render, staticRenderFns } from "./MyButtonMobile.vue?vue&type=template&id=8dd4f1ce&scoped=true"
import script from "./MyButtonMobile.vue?vue&type=script&lang=js"
export * from "./MyButtonMobile.vue?vue&type=script&lang=js"
import style0 from "./MyButtonMobile.vue?vue&type=style&index=0&id=8dd4f1ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd4f1ce",
  null
  
)

export default component.exports